import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { SharedService } from 'src/app/shareModule/services/shared.service';
import { CarouselComponent } from 'ngx-owl-carousel-o';
import { CommonService } from 'src/app/shareModule/services/common.service';

export interface Tab {
  title: string;
  icon?: string;
  condition?: boolean;
}

@Component({
  selector: 'app-my-tabs',
  templateUrl: './my-tabs.component.html',
  styleUrls: ['./my-tabs.component.scss']
})
export class MyTabsComponent implements OnInit {


  @ViewChild('owlElement') owlElement!: CarouselComponent;

  @Input() slider: boolean = false;
  @Input() design: string;
  @Input() size: string;
  @Input() tabs: any = [];
  @Input() defaultTabIndex: number = 0;
  @Output() tabChange = new EventEmitter<number>();

  // Options for the carousel
  public customOptions: any = {
    loop: false,
    mouseDrag: true,
    touchDrag: true,
    pullDrag: true,
    dots: true,
    navSpeed: 700,
    nav: false, // Hide default next/prev buttons if using custom ones
    autoplay: false,
    items: 2
  };

  public timeout: any = null;
  public tabList: Array<Tab> = [];

  constructor(
    private sharedService: SharedService,
    public commonService:CommonService,
  ) { }

  ngOnInit() {
    // this.initTabs()
    // you can change defaultTabIndex from page instead of this
    this.sharedService.selectMyTab$.subscribe((index: any) => {
      this.selectTab(index);
    });
  }

  ngOnChanges(changes): void {
    if (changes['defaultTabIndex']) {
      this.selectTab(changes.defaultTabIndex.currentValue)
    }
    if (changes['tabs']) {
      this.initTabs()
    }
  }


  public initTabs(): void {

    if (this.tabs) {
      this.tabList = this.tabs.map((e) => ({
        condition: true,
        ...e
      }));

      this.tabList.some((e, i) => {
        if (e.condition) {
          this.defaultTabIndex = i
          return true;
        }
      })

    }

  }

  selectTab(index: number) {
    this.defaultTabIndex = index;
    this.tabChange.emit(this.defaultTabIndex);
  }



  // // Go to the next slide
  // next() {
  //   this.owlElement.next(); // Passing a speed argument (200ms)
  // }

  // // Go to the previous slide
  // prev() {
  //   this.owlElement.prev();
  // }


}
